import firebase from "firebase";
const firebaseConfig = {
  apiKey: "AIzaSyDZ20iFzjqKRkZMGq4DYD2CbT2NvobXvbs",
  authDomain: "my-netfilx-clone.firebaseapp.com",
  projectId: "my-netfilx-clone",
  storageBucket: "my-netfilx-clone.appspot.com",
  messagingSenderId: "1017874014724",
  appId: "1:1017874014724:web:91803fb3caff305e07cb51",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
export { auth };
export default db;
